import { render, staticRenderFns } from "./DropRefun.vue?vue&type=template&id=65ee24cd&scoped=true&"
import script from "./DropRefun.vue?vue&type=script&lang=js&"
export * from "./DropRefun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee24cd",
  null
  
)

export default component.exports